import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import { ButtonWrapper, ExpandButton } from './ChevronButton.styles';

interface IProps {
  className: string;
  handleClick: () => void;
  icon: string;
  textId: string;
}

function ChevronButton(props: IProps): ReactElement {
  const { className, handleClick, icon, textId } = props;

  return (
    <ButtonWrapper className={`${className}`} onClick={handleClick}>
      <img className={`${className}__icon`} src={icon} alt="chevron icon" />
      <ExpandButton className={`${className}__show-button`}>
        <FormattedMessage id={textId} />
      </ExpandButton>
    </ButtonWrapper>
  );
}

export default ChevronButton;
